import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userCards: [], // Array of card IDs that user has in their binder
};

const binderSlice = createSlice({
  name: 'binder',
  initialState,
  reducers: {
    addCardToBinder: (state, action) => {
      if (!state.userCards.includes(action.payload)) {
        state.userCards.push(action.payload);
      }
    },
    removeCardFromBinder: (state, action) => {
      state.userCards = state.userCards.filter(cardId => cardId !== action.payload);
    },
  },
});

export const { addCardToBinder, removeCardFromBinder } = binderSlice.actions;
export default binderSlice.reducer; 